import { GraphQLClient } from "../../../../../shared/gql-client";
import * as gqlBuilder from "gql-query-builder";
import { TruckModel } from "../../domain/models/truckModel";
import { gql } from "@apollo/client";

export default class TruckService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  getTrucks(): Promise<TruckModel[]> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.query({
        operation: "trucks",
        variables: {
          first: 1000,
        },
        fields: [
          {
            data: [
              "id",
              "title",
              "licence",
              "capacity",
              {
                driver: ["id", "name"],
              },
              "length",
              "width",
            ],
          },
        ],
      });

      this.client
        ?.query("trucks", gql(query), variables)
        .then((response) => {
          const data = response as { data: TruckModel[] };
          if (!data.data || data.data.length === 0) {
            resolve([]);
          }

          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
